import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, isOnboardingBlocking } from './AuthProvider'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, loading, onboarded, onboardingPhase } = useAuth()
  const location = useLocation()

  if (loading || (session && onboarded === null)) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-950 text-white">
        <div className="animate-pulse text-lg">A carregar...</div>
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace />
  }

  // s60 — ProtectedRoute passa a olhar para `onboarding_phase` em vez de
  // `onboarded_at`. Fases bloqueantes (phase1-4) → /onboarding. Fases
  // abertas (phase5_chat, complete, abandoned) → chat desbloqueado.
  // `onboarding_phase = null` significa user que nunca começou o pipeline
  // — também o mandamos para /onboarding para entrar pelo fluxo normal
  // (OAuth callback stamps phase1_ingestion, se chegar cá com null é
  // porque não passou pelo OAuth ainda — fluxo normal é login → OAuth).
  const blocking = isOnboardingBlocking(onboardingPhase)

  // Caso especial: user antigo onde `onboarding_phase` é null mas já
  // tinha `onboarded_at` setado (backfilled pela migration para 'complete').
  // A migration já trata disto — mas como defesa extra, aceitamos
  // onboarded=true como "passe" mesmo quando phase é null.
  const phaseTreatsAsComplete = onboardingPhase === null && onboarded === true

  if (blocking && !phaseTreatsAsComplete && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />
  }

  // Quando o user já está em fase aberta mas ainda está no /onboarding,
  // redireciona para /chat automaticamente (ex: acabou de clicar "avançar"
  // na Fase 4 e a rota ainda não transitou).
  if (
    !blocking &&
    !phaseTreatsAsComplete &&
    onboardingPhase !== null &&
    location.pathname === '/onboarding'
  ) {
    return <Navigate to="/chat" replace />
  }

  return <>{children}</>
}
